import React, { Component, Fragment } from 'react';
import agent from '../../../agent'
import { connect } from 'react-redux';
import { agreeInfo1, agreeInfo2, agreeInfo3 } from './joinAgree';
import { Link } from 'react-router-dom';
import ACTS from '../../../constants'
import LoadingCircularBar from '../../common/loadingCircularBar';
import { getParameters } from '../../../utils/common'

const mapStateToProps = state => ({ ...state.join, ...state.common });

const mapDispatchToProps = dispatch => ({
    //join
    onJoinStep: step => 
      dispatch({ type: ACTS.JOIN_STEP, step}), 
    onMemberCheckId: userId =>
      dispatch({ type: ACTS.MEMBER_CHECK_ID, payload: agent.Auth.memberCheckId(userId) }),
    updateErrors: params =>
      dispatch({ type: ACTS.MEMBER_CHECK_ERROR, ...params}),
    onMemberJoin: params =>
      dispatch({ type: ACTS.MEMBER_JOIN, payload: agent.Auth.memberJoin(params) }),      
    onLogin: (id, password) =>
        dispatch({ type: ACTS.LOGIN, payload: agent.Auth.login(id, password), redirect: true, id }),
    getAgencyList: parentCd =>
      dispatch({ type: ACTS.AGENCY, payload: agent.Common.agency(parentCd) }),
    onSearchSurveyList: () =>
      dispatch({ type: ACTS.CODE_LIST, payload: agent.Common.searchCodeList('JOIN_SURVEY') }),
    onAgencyUnload: () => 
      dispatch({ type: ACTS.AGENCY_UNLOADED }),      
    onSurveyListUnload: () =>
      dispatch({ type: ACTS.SURVEY_LIST_UNLOADED }),

    //common
    onSubmit: (certifyKind, id, password) =>      
      dispatch({ type: ACTS.LOGIN, payload: agent.Auth.login(certifyKind, id, password) }),
});

const Alert = window.Alert;

class Login extends Component {    
    constructor(props) {
        super();
        this.agree01 = null;
        this.agree02 = null;
        this.agree03 = null;    
        this.userId = null;   
        this.survey = null;
        this.userNm = '';
        this.userId = '';
        this.userPwd = '';
        this.companyNm = '';
        this.agCode = '';
        this.isHunma = window.location.href.indexOf("hunma-join") !== -1;

        //제휴사코드
        this.ac = window.sessionStorage.getItem('ac');
        if(!this.ac){
            this.ac = getParameters('ac');
            if(this.ac){
                window.sessionStorage.setItem('ac', this.ac);
            }
        }
        
        props.onJoinStep(1);        

        this.onChoiceSurvey = survey => {
            this.survey = survey;
        }

        // 아이디 변경
        this.onMemberCheckId = () => {        
          const userId = this.refs.userId.value;

          if(userId !== userId.replace(/ /g, '')) {
            this.props.updateErrors({ errorUserId: 1});
            return;
          }else if(window.regExpPattern('email').test(userId) === false){
            this.props.updateErrors({ errorUserId: 2});
            return;
          }else{          
            this.props.onMemberCheckId(this.refs.userId.value);
            return;
          }
        }

        // 비밀번호 변경
        this.onMemberPasswd = () => {
            const userPwd = this.refs.userPwd.value;
            if(userPwd){
                if(userPwd !== userPwd.replace(/ /g, '')) {
                    this.props.updateErrors({ errorUserPwd: 1}); return;
                }else if(userPwd.length < 6) {
                    this.props.updateErrors({ errorUserPwd: 2}); return;
                }
            }

            this.props.updateErrors({ errorUserPwd: 0});
        }

        // 비밀번호 확인 변경
        this.onMemberPasswd2 = () => {
            const userPwd = this.refs.userPwd.value;
            const userPwd2 = this.refs.userPwd2.value;
            if(userPwd !== userPwd2) {
                this.props.updateErrors({ errorUserPwd2: 1}); return;
            }

            this.props.updateErrors({ errorUserPwd2: 0});
        }

        this.onHpChange = key => {
            const hp = this.refs[key].value;
            var number = hp.replace(/[^0-9]/g, "");
            var phone = "";

            if(number.length < 4) {
                phone = number;
            } else if(number.length < 7) {
                phone += number.substr(0, 3);
                phone += "-";
                phone += number.substr(3);
            } else if(number.length < 11) {
                phone += number.substr(0, 3);
                phone += "-";
                phone += number.substr(3, 3);
                phone += "-";
                phone += number.substr(6);
            } else {
                phone += number.substr(0, 3);
                phone += "-";
                phone += number.substr(3, 4);
                phone += "-";
                phone += number.substr(7);
            }
            this.refs[key].value = phone;
        }

        this.onHpFocus = key => {
            const hp = this.refs[key].value;
            var number = hp.replace(/-/g, "");
            this.refs[key].value = number;
        }
/*
        this.onExtHpFocus = () => {
            const hp = this.refs.agencyExtPhone.value;
            var number = hp.replace(/-/g, "");
            this.refs.agencyExtPhone.value = number;
        }
*/
        this.onSubmit = () => ev => {
            if(!this.agree01 || !this.agree02){
                Alert.info("이용약관과 개인정보 수집 및 이용안내에 모두 동의해주세요.");
                this.props.onJoinStep(1);
                return;
            }

            ev.preventDefault();    
          
            const companyNm = this.refs.companyNm.value.replace(/ /g, '');
            const userNm = this.refs.userNm.value.replace(/ /g, '');
            const userId = this.refs.userId.value.replace(/ /g, '');
            const userPwd = this.refs.userPwd.value.replace(/ /g, '');
            const userPwd2 = this.refs.userPwd2.value.replace(/ /g, '');
            const agCode = this.refs.agCode.value;
            let phone = this.refs.phone.value.replace(/ /g, '');
            let agencyExtCode = "";
            let agencyExtPhone = "";
            
            if(this.isHunma){
                agencyExtCode = this.refs.agencyExtCode.value.replace(/ /g, '');
                agencyExtPhone = this.refs.agencyExtPhone.value.replace(/ /g, '');
            }            

            if(companyNm === ""){
                Alert.info('회사명을 입력하세요.');return;
            }
            if(userNm === ""){
                Alert.info('이름을 입력하세요.');return;
            }
            if(userId === ""){
                Alert.info('아이디를 입력하세요.');return;
            }
            if(this.props.errorUserId === 1 || userId !== this.refs.userId.value){
                Alert.info('아이디는 공백을 입력할 수 없습니다.');return;
            }
            if(this.props.errorUserId === 2 || window.regExpPattern('email').test(userId) === false){
                Alert.info('이메일형식의 아이디가 아닙니다.');return;
            }
            if(this.props.errorUserId === 3){
                Alert.info('사용중인 아이디 입니다.');return;
            }
            if(userPwd === ""){
                Alert.info('비밀번호를 입력하세요.');return;
            }
            if(this.props.errorUsePwd === 2 || userPwd.length < 6){
                Alert.info('비밀번호 길이가 작습니다.(6자리이상)');return;
            }
            if(userPwd2.replace(/ /g, '') === ""){
                Alert.info('비밀번호 확인을 입력하세요.');return;
            }
            if(this.props.errorUsePwd === 1 || userPwd !== userPwd2){
                Alert.info('비밀번호가 일치하지 않습니다.');return;
            }
            if(phone === ''){
                Alert.info('휴대전화를 입력하세요.');return;
            }

           
            var num = phone;
            var type = 1;
            if(num.length==11){
                if(type==0){
                    phone = num.replace(/(\d{3})(\d{4})(\d{4})/, '$1-****-$3');
                }else{
                    phone = num.replace(/(\d{3})(\d{4})(\d{4})/, '$1-$2-$3');
                }
            }else if(num.length==8){
                phone = num.replace(/(\d{4})(\d{4})/, '$1-$2');
            }else{
                if(num.indexOf('02')==0){
                    if(type==0){
                        phone = num.replace(/(\d{2})(\d{4})(\d{4})/, '$1-****-$3');
                    }else{
                        phone = num.replace(/(\d{2})(\d{4})(\d{4})/, '$1-$2-$3');
                    }
                }else{
                    if(type==0){
                        phone = num.replace(/(\d{3})(\d{3})(\d{4})/, '$1-***-$3');
                    }else{
                        phone = num.replace(/(\d{3})(\d{3})(\d{4})/, '$1-$2-$3');
                    }
                }
            }

                        
            const params = {agCode, companyNm, userNm, userId, userPwd, phone, survey: this.survey, 
                agree01: this.agree01 ? "Y" : "N", agree02: this.agree02 ? "Y" : "N", agree03: this.agree03 ? "Y" : "N",
                agencyExtCode, agencyExtPhone};

            this.userNm = userNm;
            this.userId = userId;
            this.userPwd = userPwd;
            this.props.onMemberJoin(params);
        }

        this.onAgree = () => {
            if(!this.refs.agree01.checked || !this.refs.agree02.checked){
                Alert.info("이용약관과 개인정보 수집 및 이용안내에 모두 동의해주세요.");
            }else{
                this.agree01 = this.refs.agree01.checked;
                this.agree02 = this.refs.agree02.checked;
                this.agree03 = this.refs.agree03.checked;
                this.props.onJoinStep(2);
                this.props.onSearchSurveyList();

                if(this.isHunma){
                    this.props.getAgencyList('SBP-A0016'); // 훈마 코드
                }else{
                    this.props.getAgencyList();
                }
            }
        }
    };

    componentWillUpdate(nextProps, nextState) {
        if(nextProps.step === 3 && nextProps.complete === false){
            nextProps.onJoinStep(2);
            Alert.info("중복된 아이디가 존재합니다.\n\n아이디를 변경하세요.");
            return;
        }else if(nextProps.step === 3 && nextProps.complete === true){
            //nextProps.onLogin("SN", this.userId, this.userPwd);
            this.props.onAgencyUnload(); //에이전시 리스트 초기화
            this.props.onSurveyListUnload(); //가입경로 리스트 초기화
        }
    }

    componentDidUpdate(){
        if(this.props.step === 2){
            window.$('.formInput').focus(function(){
                window.$(this).siblings('label').addClass('active');
            });
            window.$('.formInput').blur(function(){
                var val = window.$(this).val();
                if(val !== ''){
                    window.$(this).siblings('label').addClass('active');
                }else{
                    window.$(this).siblings('label').removeClass('active');
                }
            });
        }
    }

    onChange = () => {
        window.$("label[for^=agree0]").trigger("click");
    }    

    render(){      
        var aList = this.props.agencyList;

        var surveyList = this.props.joinSurvey
        
        if(aList != null){
            for(var i = 0; i < aList.length; i++){
                if(window.CryptoUtils.sha256(aList[i].CODE) == this.ac){
                    if(aList[i].AGENT_NM === '신한카드' || aList[i].AGENT_NM === "플랫타익스체인지"){
                        if(surveyList != null){
                            for(var j = 0; j < surveyList.length; j++){                                
                                if(surveyList[j].codeNm === '신한카드'){
                                    this.survey = surveyList[j].code;
                                    window.$('.surveyDiv').hide();
                                }else if(surveyList[j].codeNm === '플랫타익스체인지'){
                                    window.$('.surveyDiv').hide();
                                }                                
                            }
                        }
                    }
                }
            }
        }

        // 제휴사 자동지정
        let displayAgency = '';
        if(this.props.agencyList && window.SERVICE_NM !== "success"){
            for(let i=0; i<this.props.agencyList.length; i++){
                const agency = this.props.agencyList[i];
                if(window.SERVICE_NM === "erp" && agency.WEB_SERVICE == "SFERP"){
                    this.ac = window.CryptoUtils.sha256(agency.CODE);
                    displayAgency = 'none';
                }else if(window.SERVICE_NM === "npo" && agency.WEB_SERVICE == "NPO"){
                    this.ac = window.CryptoUtils.sha256(agency.CODE);
                    displayAgency = 'none';
                }
            }
        }

        return (  
            <Fragment>
            <LoadingCircularBar />
            <div className="easyJoinBgWrap">
            {
                this.props.step === 1 &&
                <Fragment>
                <div className="easyJoinWrap">
                    <a href="#" className="agreeBtn mb20" onClick={ this.onChange }>약관에 모두 동의 </a>
                    <div className="easyJoinSect">
                        <div className="agreeSect">
                            <div>
                                <h2 className="areaTitle">
                                    <span className="f_lt">약관동의 <strong style={{color: 'rgb(255, 34, 0)', fontSize: '12px', fontWeight: 'bold' }}>[필수]</strong></span>
                                    <span className="imgChkBox2 f_rt">
                                        <label className="imgChkBoxLabel" htmlFor="agree01"> 동의함</label>
                                        <input className="imgChkBoxInput" id="agree01" type="checkbox" ref="agree01" />
                                    </span>
                                </h2>
                                <div>
                                    { agreeInfo1() }
                                </div>
                            </div>
                            <div className="mt20">
                                <h2 className="areaTitle">
                                    <span className="f_lt">개인정보수집 및 이용안내 <strong style={{ color: 'rgb(255, 34, 0)', fontSize: '12px', fontWeight: 'bold' }}>[필수]</strong></span>
                                    <span className="imgChkBox2 f_rt">
                                        <label className="imgChkBoxLabel lbOff" htmlFor="agree02"> 동의함</label>
                                        <input className="imgChkBoxInput" id="agree02" type="checkbox" ref="agree02" />
                                    </span>
                                </h2>
                                { agreeInfo2() }
                            </div>
                            <div style={{ clear: 'both' }}></div>
                        </div>
                        <div className="agreeSect">
                            <div className="mt20">
                                <h2 className="areaTitle">
                                    <span className="f_lt">제3자 개인정보제공 동의 <strong style={{ color: 'rgb(0, 102, 255)', fontSize: '12px', fontWeight: 'bold' }}>[선택]</strong></span>
                                    <span className="imgChkBox2 f_rt">
                                        <label className="imgChkBoxLabel lbOff" htmlFor="agree03"> 동의함</label>
                                        <input className="imgChkBoxInput" id="agree03" type="checkbox" ref="agree03" />
                                    </span>
                                </h2>  
                                { agreeInfo3() }
                                <p style={{ fontSize: '12px', color: '#f50', textAlign: 'left', paddingTop: '5px', lineHeight: '1.7' }}>
                                    ※ 3자제공동의를 거부해도 가계부 기본서비스 이용 가능<br/> 
                                    ※ 단, 재무상담 등 세무관련 서비스 이용 시 추가 동의가 필요
                                </p>
                            </div>
                            <div style={{ clear: 'both' }}></div>
                        </div>
                    </div>
                </div>
                <div className="joinBtnWrap">
                    <Link className="cancelBtn" to="/login">취소</Link>
                    <a className="cFmBtn" onClick={ this.onAgree }>동의하기</a>
                </div>
            </Fragment>  
            }
            
            {
                this.props.step === 2 &&
                <Fragment>
                <div className="easyJoinWrap" style={{ paddingTop:'15px', backgroundColor:'#f5f6f7' }}>
                    <div className="easyJoinSect">
                        <div className="agreeSect">
                            <div className="accForm"  style={{ marginBottom:'15px', display: displayAgency}}>
                                <select name="agCode" className="vm agCodeSelect" id="agCode" ref="agCode">
                                {                                        
                                    this.props.agencyList && this.props.agencyList.length !== 0 && this.props.agencyList.map((item, idx) =>
                                        !this.ac ? 
                                            idx === 0 ?                                            
                                                item.CODE !== 'SUCCESS' ?
                                                    <Fragment key={ idx }>
                                                        <option value="">소개받은 제휴사 선택</option>
                                                        { !this.isHunma && <option value="SUCCESS">선택안함</option> }
                                                        <option value={ item.CODE }> { item.CODE } : { item.AGENT_NM } </option>
                                                    </Fragment>
                                                    :
                                                    <Fragment key={ idx }>
                                                        <option value="">소개받은 제휴사 선택</option>
                                                        <option value="SUCCESS">선택안함</option>                                                        
                                                    </Fragment>
                                            :
                                            item.CODE !== 'SUCCESS' && item.DISPLAY_YN === 'Y' ?                                            
                                                <option value={ item.CODE } key={ idx }> { item.CODE } : { item.AGENT_NM } </option>
                                                :
                                                ''
                                        :
                                        <Fragment key={ idx }>
                                            {
                                                window.CryptoUtils.sha256(item.CODE) == this.ac ?
                                                <option value={ item.CODE } selected> { item.CODE } : { item.AGENT_NM } </option>
                                                :
                                                ''
                                            }
                                        </Fragment>
                                        
                                    )
                                }
                                </select>
                                <div style={{ clear: 'both' }}></div>
                            </div>
                            <div className="joinInWrap">
                               { this.isHunma && 
                               <div className="accForm">
                                    <label className="labels" htmlFor="agencyExtCode">추천인 이름</label>
                                    <input name="agencyExtCode" id="agencyExtCode" className="formInput vm" type="text" maxLength="20" ref="agencyExtCode" />
                                    <div style={{ clear: 'both' }}></div>
                               </div>
                                }

                               { this.isHunma && 
                               <div className="accForm">
                                    <label className="labels" htmlFor="agencyExtPhone">추천인 연락처</label>
                                    <input name="agencyExtPhone" id="agencyExtPhone" className="formInput vm" type="tel" maxLength="15" ref="agencyExtPhone" onFocus={ () => this.onHpFocus('agencyExtPhone') } onBlur={ () => this.onHpChange('agencyExtPhone') } />
                                    <div style={{ clear: 'both' }}></div>
                               </div>                               
                               }
                               <div className="accForm">
                                    <label className="labels" htmlFor="companyNm">회사명</label>
                                    <input name="companyNm" id="companyNm" className="formInput vm" type="text" maxLength="20" ref="companyNm" />
                                    <div style={{ clear: 'both' }}></div>
                               </div>
                               <div className="accForm">
                                    <label className="labels" htmlFor="accName">성명 또는 대표자명</label>
                                    <input name="name" id="accName" className="formInput vm" type="text" maxLength="20" ref="userNm" />
                                    <div style={{ clear: 'both' }}></div>
                                </div>
                                <div className="accForm">
                                    <label className="labels" htmlFor="accId">아이디 (이메일형식 예)id@naver.com)</label>                                
                                    <input name="id" id="accId" className="formInput vm" type="email" maxLength="40" ref="userId" checkpattern="email" minlen="6" onBlur={ this.onMemberCheckId }/>
                                    <p className="subScriptBad" style={{ display: this.props.errorUserId === 1 ? 'block' : 'none' }}>※ 아이디는 공백을 입력할 수 없습니다.</p>
                                    <p className="subScriptBad" style={{ display: this.props.errorUserId === 2 ? 'block' : 'none' }}>※ 이메일 형식이 아닙니다.</p>
                                    <p className="subScriptBad" style={{ display: this.props.errorUserId === 3 ? 'block' : 'none' }}>※ 중복된 아이디가 존재합니다.</p>
                                    <div style={{ clear: 'both' }}></div>
                                </div>
                                <div className="accForm">
                                    <label className="labels" htmlFor="accPass1">비밀번호 (최소 6자리이상, 공백사용불가)</label>
                                    <input name="passwd" id="accPass1" className="formInput vm" type="password" size="30" maxLength="30" ref="userPwd" minlen="6" onBlur={ this.onMemberPasswd } />
                                    <p className="subScriptBad" id="ctlPasswdBad2" style={{ display: this.props.errorUserPwd === 1 ? 'block' : 'none' }}>※ 비밀번호는 공백을 입력할 수 없습니다.</p>
                                    <p className="subScriptBad" id="ctlPasswdBad" style={{ display: this.props.errorUserPwd === 2 ? 'block' : 'none' }}>※ 비밀번호는 최소 6자리 이상 입력이 가능합니다.</p>
                                    <div style={{ clear: 'both' }}></div>
                                </div>
                                <div className="accForm">
                                    <label className="labels" htmlFor="accPass2">비밀번호 확인</label>
                                    <input name="passwdChk" id="accPass2" className="formInput vm" type="password" size="30" ref="userPwd2" onBlur={ this.onMemberPasswd2 } />
                                    <p className="subScriptBad" id="ctlPasswdChkBad" style={{ display: this.props.errorUserPwd2 === 1 ? 'block' : 'none' }}>※ 비밀번호를 확인해 주세요</p>
                                    <div style={{ clear: 'both' }}></div>
                                </div>
                                <div className="accForm">
                                    <label className="labels" htmlFor="accPhone">휴대전화 번호</label>
                                    <input name="hp" id="accPhone" className="formInput vm" type="tel" maxLength="15" ref="phone" onFocus={ () => this.onHpFocus('phone') } onBlur={ () => this.onHpChange('phone') } />
                                    <div style={{ clear: 'both' }}></div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                { 
                !this.isHunma &&
                <div className="joinInWrap surveyDiv" style={{ margin:'0 10px'}}>
                    <h2 className="areaTitle ac" style={{ backgroundPosition: '0px 0px', padding: '0px 0px 4px 0px', overflow: 'hidden' }}>
                        서비스를 아시게 된 경로를 선택하세요.
                    </h2>
                    <div className="joinRootDiv">
                        <ul>
                            {
                            this.props.joinSurvey && this.props.joinSurvey.length !== 0 && this.props.joinSurvey.map(item =>
                                <li key={ item.code }>
                                    <span className="imgChkBox">
                                        <input name="survey" className="imgChkBoxInput" id={ 'joinType' + item.code } type="radio" value="{ item.code }" />
                                        <label className="imgChkBoxLabel" name="survey" htmlFor={ 'joinType' + item.code } onClick={ () => this.onChoiceSurvey(item.code) }>{ item.codeNm }</label>
                                    </span>
                                </li>
                            )
                            }   
                        </ul>
                    </div>
                </div>
                }
                <div className="joinBtnWrap">
                    <Link className="cancelBtn" to="/login">취소</Link>
                    <a className="cFmBtn"  onClick={ this.onSubmit() }>회원가입 신청</a>
                </div>
                </Fragment>
            }

            {
                this.props.step === 3 && this.props.complete === true && 
                <div className="easyJoinWrap" style={{height:'100vh'}}>
                    <div className="easyJoinSect">
                        <div className="agreeSect">
                            <div className="join_ok" style={{ marginTop: '50px' }}>
                                <h3>회원가입이 <strong>정상적으로 완료 되었습니다.</strong></h3>
                                <p className="ok_depth01"><strong>{ this.userNm }</strong>님의 가입 아이디는 <br/><br/><strong className="t_red b" style={{ color:'#000' }}>{ this.userId }</strong>입니다.</p>
                                <div style={{ overflow: 'hidden' }}>
                                    <div className="ok_depth02 ok_hover" style={{ backgroundColor:'#fff' }}>
                                        <p style={{ fontWeight: 'normal' }}><strong style={{ fontSize: '24px' }}>환영합니다.</strong><br/>이제 정상적으로 서비스를 이용하실 수 있습니다.</p>
                                        <a href="javascript:;" className="cFmBtn" style={{ margin: '20px auto', width: '80%', float: 'none', display: 'block', borderRadius:'50px' }} onClick={ ()=> this.props.onLogin(this.userId, this.userPwd) } >서비스 입장하기</a>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            }
            </div>   

            </Fragment>
        )
    }
}

						
                        
export default connect(mapStateToProps, mapDispatchToProps)(Login);


// WEBPACK FOOTER //
// ./src/components/pages/member/join.js